<template lang="pug">
    div.report-list(v-if="currentComponent")
        component(
            :is="currentComponent"
            ref="reportListEditComponent"
        )
</template>

<script>
export default {
    name: 'ReportListEdit',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-report/views/pages/edit/components/report-list/content.vue')
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin-bottom: 16px;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
</style>
